import {Component, Vue, Watch} from 'vue-property-decorator'
import {UserProfile} from "@api/models/UserProfile";
import {ProfileListHelper} from "../share/profile/helpers/ProfileListHelper";
import {Participant} from "../api/models/meetings/Participant";
import {detectMob} from "../common/mobileHelper";
// import {addHashToRoute} from "../common/addHasToRoute";
import {EventBus} from "@common/EventBus";

@Component
class WithProfileMixin extends Vue {
    showProfile = false;
    profileListHelper: ProfileListHelper | null = null;
    closeTimeout = 300;
    callback: null | (() => void) = null;
    switchModalAfterCLose = true;

    created() {
        this.profileListHelper = new ProfileListHelper((this as any).$repositories, this.$store);
    }

    async selectProfile(participant: UserProfile | Participant | number) {
        const userId = typeof participant == 'number' ? participant : participant.userId;
        await this.profileListHelper?.setSelected(userId as number);
        this.showProfile = true;
    }

    hideProfile() {
        this.profileListHelper?.deselect();
        setTimeout(() => {
            this.showProfile = false;
            if (this.callback) {
                this.callback();
            }
        }, this.closeTimeout);
        if (detectMob() && this.switchModalAfterCLose) {
            EventBus.$emit('modalClosed');
        }
    }

    closeProfile(callback: undefined | (() => void) = undefined) {
        this.profileListHelper?.deselect();
        this.showProfile = false;
        callback && (this.callback = callback);
    }
}

export default WithProfileMixin
